<template>
    <div class="mb-3">
        <div class="mb-3 border-bottom border-color-gray-700">
            <h5> category2 질문제목 검색 </h5>
        </div>

        <b-form-input
            id="questionname_category2_search"
            v-model.trim="searchCategory2name"
            placeholder="질문제목 또는 질문코드 검색"
            debounce="700"
            class="mb-2"
            :disabled="is_empty_template_meta"
            />

        <div v-show="searchCategory2name && !is_empty_template_meta" class="text-secondary font-italic mb-3 rounded mb-3 small">
            <p class="mb-0">검색어를 지우고 enter를 치시면 전체 목록을 보실 수 있습니다.</p>
        </div>

        <div
            v-show="searchCategory2name && searched_result_category2_list && !searched_result_category2_list.length"
            class="p-3 bg-light rounded font-italic"
            >
            <p class="mb-0">검색된 category2 이름이 없습니다.</p>
        </div>
        <b-list-group v-show="searched_result_category2_list && searched_result_category2_list.length"
            class="border searched_result_category2_list"
            >
            <b-list-group-item v-for="_searched in searched_result_category2_list"
                :key="`category2s-${_searched.category2_code}-${_searched.index}`"
                class="px-3"
                >
                <div class="d-flex align-items-center">
                    <div class="flex-grow-0">
                        <b-badge class="mr-2" pill>{{ _searched.category2_code }}</b-badge>
                    </div>
                    <div class="flex-grow-1">
                        {{ _searched.category2_name }}
                    </div>
                    <div class="flex-grow-0">
                        <b-btn variant="light" size="sm" @click="addCategory2Question(_searched.category2_name)" :disabled="disabled">
                            <fa icon="plus" />
                        </b-btn>
                    </div>
                </div>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import FuzzySearch from 'fuzzy-search';

export default {
    name: 'category2-search-group',
    props: {
        category2_list: {
            required: true,
            type: [ Array ]
        },
        disabled: {
            required: true,
            type: Boolean
        }
    },
    data () {
        return {
            searchCategory2name: null,
            searched_result_category2_list: null
        }
    },
    computed: {
        ...mapState(['template_tree']),
        is_empty_template_meta () {
            return this.isFieldEmpty(this.template_tree.template_name) || this.isFieldEmpty(this.template_tree.template_type)
        }
    },
    watch: {
        searchCategory2name (_search_cat2) {
            if (_search_cat2) {
                this.searchCategory2()
            } else {
                this.searched_result_category2_list = this.category2_list
            }
        }
    },
    created () {
        this.searched_result_category2_list = this.category2_list
    },
    mounted () {},
    methods: {
        searchCategory2 () {
            const searcher = new FuzzySearch(this.category2_list, ['category2_name', 'category2_code'], {
                caseSensitive: false
            });
            const result = searcher.search(this.searchCategory2name);
            this.searched_result_category2_list = result 
            
        },
        addCategory2Question (category2Name) {
            this.$emit('add-category2-question', category2Name)
        }
    }
}
</script>

<style lang="scss" scoped>
.searched_result_category2_list {
    max-height: 245px;
    overflow-y: auto;
}
</style>